module.exports = __webpack_public_path__ + "static/img/check.bac21192.svg";